import { Routes } from '@angular/router';

import { MsalGuard } from '@azure/msal-angular';

import { AdminGuard } from './guards/admin-guard.guard';

import { AgreementGuard } from './guards/agreement-guard.guard';

import { UnsavedChangesGuard } from './guards/unsaved-changes.guard';

export const routes: Routes = [
  {
    path: 'user-agreement',
    loadComponent: () =>
      import('./pages/user-agreement/user-agreement.component').then((m) => m.UserAgreementComponent),
    canActivate: [],
  },
  {
    path: 'item-view',
    loadComponent: () => import('./pages/item-view/item-view.component').then((m) => m.ItemViewComponent),
    canActivate: [MsalGuard],
  },
  {
    path: '',
    loadComponent: () => import('./components/app-layout/app.layout.component').then((m) => m.AppLayoutComponent),
    children: [
      {
        path: '',
        loadComponent: () => import('./pages/landing/landing.component').then((m) => m.LandingComponent),
        canActivate: [MsalGuard, AgreementGuard],
      },
      {
        path: 'system-settings',
        loadComponent: () => import('./pages/home/home.component').then((m) => m.HomeComponent),
        canActivate: [MsalGuard, AdminGuard, AgreementGuard],
        children: [
          {
            path: 'glossary',
            loadComponent: () => import('./pages/glossary/glossary.component').then((m) => m.GlossaryComponent),
            canActivate: [MsalGuard, AdminGuard, AgreementGuard],
          },
          {
            path: 'catalog',
            loadComponent: () => import('./pages/catalog/catalog.component').then((m) => m.CatalogComponent),
            canActivate: [MsalGuard, AdminGuard, AgreementGuard],
          },
          {
            path: 'register-departments',
            loadComponent: () =>
              import('./pages/register-department/register-department.component').then(
                (m) => m.RegisterDepartmentComponent
              ),
            canActivate: [MsalGuard, AdminGuard, AgreementGuard],
          },
          {
            path: 'general-settings',
            loadComponent: () =>
              import('./pages/general-settings/general-settings.component').then((m) => m.GeneralSettingsComponent),
            canActivate: [MsalGuard, AdminGuard, AgreementGuard],
          },
          {
            path: 'addons',
            loadComponent: () => import('./pages/addons/addons.component').then((m) => m.AddonComponent),
            canActivate: [MsalGuard, AdminGuard, AgreementGuard],
            children: [
              {
                path: '',
                loadComponent: () =>
                  import('./pages/addons/addon-list/addon-list.component').then((m) => m.AddonListComponent),
                canActivate: [MsalGuard, AdminGuard, AgreementGuard],
              },
              {
                path: 'settings',
                loadComponent: () =>
                  import('./pages/addons/addon-settings/addon-settings.component').then(
                    (m) => m.AddonSettingsComponent
                  ),
                canActivate: [MsalGuard, AdminGuard, AgreementGuard],
                canDeactivate: [UnsavedChangesGuard],
              },
            ],
          },
          {
            path: 'users-groups',
            loadComponent: () =>
              import('./pages/users-groups/users-groups.component').then((m) => m.UsersGroupsComponent),
            canActivate: [MsalGuard, AdminGuard, AgreementGuard],
          },
          {
            path: 'admin-users',
            loadComponent: () => import('./pages/admin-users/admin-users.component').then((m) => m.AdminUsersComponent),
            canActivate: [MsalGuard, AdminGuard, AgreementGuard],
          },
          {
            path: 'seals',
            loadComponent: () => import('./pages/seals/seals.component').then((m) => m.SealsComponent),
            canActivate: [MsalGuard, AdminGuard, AgreementGuard],
          },
        ],
      },
      {
        path: 'login-failed',
        loadComponent: () => import('./pages/failed/failed.component').then((m) => m.FailedComponent),
        canActivate: [MsalGuard],
      },
      {
        path: 'store',
        loadComponent: () => import('./pages/store/store.component').then((m) => m.StoreComponent),
        canActivate: [MsalGuard, AgreementGuard],
      },
      {
        path: 'access-dashboard',
        loadComponent: () => import('./pages/dashboard/dashboard.component').then((m) => m.DashboardComponent),
        canActivate: [MsalGuard, AdminGuard, AgreementGuard],
      },
      {
        path: 'my-catalog',
        loadComponent: () => import('./pages/my-catalog/my-catalog.component').then((m) => m.MyCatalogComponent),
        canActivate: [MsalGuard, AgreementGuard],
      },
      {
        path: 'item-requests',
        loadComponent: () =>
          import('./pages/item-requests/item-requests.component').then((m) => m.ItemRequestsComponent),
        canActivate: [MsalGuard, AgreementGuard],
      },
      {
        path: 'search',
        loadComponent: () => import('./pages/item-search/item-search.component').then((m) => m.ItemSearchComponent),
        canActivate: [MsalGuard, AgreementGuard],
      },
    ],
    canActivate: [MsalGuard],
  },
  {
    path: '**',
    redirectTo: '/my-catalog',
    pathMatch: 'prefix',
  },
];
